<template>
  <div>
    <el-tabs v-model="activeName" type="border-card" style="box-shadow:none">
      <el-tab-pane
        :label="$l('INDEX.tab_pane_label_skuBase') || '基本信息'"
        name="skuBase"
        lazy
      >
        <SkuBase
          ref="skuBase"
          :disabled="disabled"
          :isCopy.sync="newIsCopy"
          @onIsCopy="onIsCopy"
          :hxSkuCode.sync="newHxSkuCode"
          :hxSpuCode="hxSpuCode"
          :hxSkuStatus.sync="hxSkuStatus"
        />
        <div class="d-flex justify-content-end mb-2 mt-2" v-if="!disabled">
          <el-button type="primary" size="small" @click="$refs.skuBase.save()">
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.tab_lable_amz_sku_fty') || '生产厂家'"
        name="skuScm"
        :disabled="!newHxSkuCode  || newIsCopy"
        lazy
      >
        <SkuScm
          ref="skuScm"
          :disabled="disabled"
          :hxSkuCode="newHxSkuCode"
          @reloadSku="$refs.skuBase.reloadSku()"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.tab_pane_label_skuImage') || '产品图片'"
        name="skuImage"
        :disabled="!newHxSkuCode  || newIsCopy"
        lazy
      >
        <SkuImage
          ref="skuImage"
          :disabled="disabled"
          :hxSkuCode="newHxSkuCode"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.form_label_sale_platform') || '销售渠道'"
        name="skuStore"
        :disabled="!newHxSkuCode  || newIsCopy"
        lazy
      >
        <SkuPlatform
          ref="skuStore"
          :disabled="disabled || hxSkuStatus === 'Q'"
          :hxSkuCode="newHxSkuCode"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import SkuBase from '../sku-base'
import SkuImage from '../sku-image'
import SkuScm from '../sku-scm'
import SkuPlatform from '../sku-platform'
export default {
  components: { SkuBase, SkuImage, SkuPlatform, SkuScm },
  props: {
    disabled: { type: Boolean, default: false },
    hxSkuCode: { type: String, default: '' },
    hxSpuCode: { type: String, default: '' },
    isCopy: { type: Boolean, default: false },
  },
  data() {
    return { activeName: 'skuBase', hxSkuStatus: '', newHxSkuCode: '', newIsCopy: false }
  },
  watch: {
    hxSkuCode: {
      handler(e) {
        if (e) this.newHxSkuCode = e
      },
      immediate: true,
    },
    isCopy: {
      handler(e) {
        if (e) this.newIsCopy = e
      },
      immediate: true,
    },
  },
  methods: {
    onIsCopy(e){
      this.newIsCopy = e
    }
  }
}
</script>
